import type { FunctionComponent } from 'react'
import React from 'react'
import { Grid, GridItem } from '@which/seatbelt'

import { ToolCTA } from '../../../../shared/components/ToolCTA'

export const HubPageToolCTA: FunctionComponent<Props> = (toolCTAProps) => (
  <Grid className="w-page-wrapper">
    <GridItem span={{ medium: 10, large: 10 }} columnStart={{ medium: 2, large: 2 }}>
      <ToolCTA {...toolCTAProps} />
    </GridItem>
  </Grid>
)

///////// IMPLEMENTATION /////////

type Props = Parameters<typeof ToolCTA>[0]
